import React from 'react';
import { Link } from 'react-router-dom';
import { PRODUCT_DISPLAY_NAME } from '../constants/branding';
import { MOBILE_APP } from '../constants/mobileApp';
import '../../assets/css/public-pages.css';

const SOCIAL_LINKS = [
  { href: 'https://www.instagram.com/nextfollowup/', icon: 'fab fa-instagram', label: 'Instagram' },
  { href: 'https://www.facebook.com/nextfollowup/', icon: 'fab fa-facebook-f', label: 'Facebook' },
];

export default function PublicFooter() {
  return (
    <footer className="pp-footer">
      <div className="pp-footer-main">
        <p className="pp-footer-copy">
          © {new Date().getFullYear()} {PRODUCT_DISPLAY_NAME} — All rights reserved.
        </p>
        <nav className="pp-footer-links" aria-label="Footer">
          <Link to="/privacy">Privacy</Link>
          <Link to="/contact-sales">Contact</Link>
          <a href={`mailto:${MOBILE_APP.supportEmail}`}>{MOBILE_APP.supportEmail}</a>
        </nav>
        <div className="pp-footer-social" aria-label="Social media">
          {SOCIAL_LINKS.map((s) => (
            <a key={s.href} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
              <i className={s.icon} aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
